import styles from "./notices-table.module.css";
import { Tooltip } from "antd";

import DotCircleFull from "@/icons/DotCircleFull";
import DotCircleEmpty from "@/icons/DotCircleEmpty";

import EmployeeProfile from "@/components/cards/EmployeeProfile";

import { formateISODateToMoment } from "@/utils";

export const COLUMN_LABELS = {
  is_read: "",
  rule: "Событие",
  change_author: "Автор изменений",
  created_at: "Дата, время",
};

export const createColumns = (onUnreadNotice, onReadNotice) => [
  {
    title: COLUMN_LABELS.is_read,
    dataIndex: "is_read",
    key: "is_read",
    width: 40,
    sorter: {
      compare: (a, b) => a.is_read - b.is_read,
    },
    render: (is_read, item) =>
      is_read ? (
        <Tooltip title="Отметить непрочитанным" placement="bottomLeft">
          <button
            className={`${styles.mail_btn}`}
            onClick={() => onUnreadNotice(item.uuid)}
          >
            <DotCircleEmpty />
          </button>
        </Tooltip>
      ) : (
        <Tooltip title="Отметить прочитанным" placement="bottomLeft">
          <button
            className={styles.mail_btn}
            onClick={() => onReadNotice([item.uuid])}
          >
            <DotCircleFull style={{ color: "#E66A25" }} />
          </button>
        </Tooltip>
      ),
  },
  {
    title: COLUMN_LABELS.rule,
    dataIndex: "rule",
    key: "rule",
    ellipsis: true,
    sorter: {
      compare: (a, b) => (a.rule?.name || "").localeCompare(b.rule?.name || ""),
    },
    render: (_, item) => (
      <Tooltip placement="bottomLeft" title={item.rule?.name}>
        {item.rule?.name}
      </Tooltip>
    ),
  },

  {
    title: COLUMN_LABELS.change_author,
    dataIndex: "change_author",
    key: "change_author",
    width: 150,
    ellipsis: { showTitle: true },
    sorter: (a, b) => {
      const type1 =
        (a.info?.change_author?.lastname || "") +
        (a.info?.change_author?.firstname || "");
      const type2 =
        (b.info?.change_author?.lastname || "") +
        (b.info?.change_author?.firstname || "");
      return type1.localeCompare(type2);
    },
    render: (_, item) =>
      item.info?.change_author && (
        <EmployeeProfile
          {...item.info?.change_author}
          fullName={false}
          avatarSize={20}
          tooltip
        />
      ),
  },
  {
    title: COLUMN_LABELS.created_at,
    dataIndex: "created_at",
    key: "created_at",
    width: 130,
    defaultSortOrder: "descend",
    sorter: {
      compare: (a, b) => (a.created_at || "").localeCompare(b.created_at || ""),
    },
    render: (_, item) => <>{formateISODateToMoment(item.created_at)}</>,
  },
];
